/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-component-legacy/upgraded-url/template/upgradedUrl.pug';
import ViewModel from '@bingads-webui-component-legacy/upgraded-url/viewmodel/upgradedUrl';
import UrlEditor from '@bingads-webui-component-legacy/url-input/view/url-input';
import FinalUrl from '@bingads-webui-component-legacy/upgraded-url/view/finalURL';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import UrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/advancedSettingsUrlOptions';
import * as _UrlOptionsV2 from '@bingads-webui-component-legacy/upgraded-url/view/urlOptionsV2';
import PageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var UrlOptionsV2 = _UrlOptionsV2.default;
function updateOnDevicePreference() {
  if (this.isMobilePreferred) {
    this.ko_model.mobileUrlVisible(false);
  } else {
    this.ko_model.mobileUrlVisible(true);
  }
}
var permissions = PageContext.Permissions || ({});
var view = backbone.View.extend({
  className: 'upgraded-url',
  initialize: function (options) {
    this.options = options || ({});
    this.isMobilePreferred = this.options.isMobilePreferred;
    this.destinationURLDisabled = this.options.destinationURLDisabled || false;
    var finalUrlSuffixPhase1EnabledEntities = ['campaign', 'adgroup', 'keyword'];
    var finalUrlSuffixPhase2EnabledEntities = ['ad', 'audience'];
    var finalUrlSuffixPhase3EnabledEntities = ['imageadextension', 'sitelink2adextension'];
    var finalUrlSuffixPhase4EnabledEntities = ['actionadextension'];
    var entity = this.options.entityType ? this.options.entityType.toLowerCase() : '';
    this.isFinalURLSuffixEnabled = finalUrlSuffixPhase1EnabledEntities.indexOf(entity) >= 0 || finalUrlSuffixPhase2EnabledEntities.indexOf(entity) >= 0 || permissions.IsFinalURLSuffixPhase3Enabled && finalUrlSuffixPhase3EnabledEntities.indexOf(entity) >= 0 || permissions.IsFinalURLSuffixPhase4Enabled && finalUrlSuffixPhase4EnabledEntities.indexOf(entity) >= 0;
    _.defaults(this.options, {
      template: tmpl,
      isFinal: true,
      urlOptionsEnabled: false,
      smallContainer: true,
      showTitles: true,
      campaignFlow: false,
      isMobilePreferred: this.isMobilePreferred,
      urlOptionsEditMode: false,
      placeholderEnabled: false,
      placeholders: {},
      showOnlyFinalUrl: false,
      landingPageUrlRequired: false,
      highLightModeInError: false,
      popupHelpKeyAdLandingPage: 'pop_BA_NewCampaignCreate_Ad_LandingPage'
    });
    if (this.destinationURLDisabled && (this.options.isFinal || !this.options.url)) {
      this.options.showOnlyFinalUrl = true;
    }
    this.ko_model = new ViewModel(this.options);
    var showAndDisableDestinationUrl = this.destinationURLDisabled && !this.options.isFinal && !!this.options.url;
    function finalUrlSelected() {
      updateOnDevicePreference.call(this);
      this.ko_model.urlOptionsVisible(this.options.urlOptionsEnabled);
      if (!this.options.isFinal) {
        this.ko_model.showUpgradeWarning(true);
      }
      this.isValid();
      this.trigger('finalUrlSelected');
      if (showAndDisableDestinationUrl) {
        this.urlEditor.setDisabled(false);
      }
    }
    function destinationUrlSelected() {
      this.ko_model.mobileUrlVisible(false);
      this.ko_model.urlOptionsVisible(false);
      this.ko_model.showUpgradeWarning(false);
      this.isValid();
      this.trigger('destinationUrlSelected');
      if (showAndDisableDestinationUrl) {
        this.urlEditor.setDisabled(true);
      }
    }
    if (!this.options.showOnlyFinalUrl) {
      this.finalUrl = new FinalUrl(this.options);
      this.finalUrl.bind('finalUrlSelected', finalUrlSelected.bind(this));
      this.finalUrl.bind('destinationUrlSelected', destinationUrlSelected.bind(this));
    }
    this.urlEditor = new UrlEditor({
      url: this.options.url,
      urlPlaceholder: this.options.placeholderEnabled ? _.result(this.options.placeholders, 'FinalUrls') || i18n.get('UpgradedUrl_Placeholder_FinalUrls') : '',
      errorContainer: 'LandingPageUrlErrors',
      ariaLabelledby: this.options.showOnlyFinalUrl ? this.options.ariaPrefix + 'FinalUrlLabel' : this.options.ariaPrefix + 'LandingPageLabel',
      ariaId: this.options.ariaPrefix + 'FinalUrl',
      required: true,
      readOnly: this.options.readOnly
    });
    this.urlEditor.on('urlChanged', function (value) {
      this.trigger('finalUrlChanged', value);
    }, this);
    if (showAndDisableDestinationUrl) {
      this.urlEditor.setDisabled(true);
    }
    this.mobileUrl = new UrlEditor({
      url: this.options.finalMobileUrl,
      urlPlaceholder: this.options.placeholderEnabled ? _.result(this.options.placeholders, 'MobileFinalUrls') || i18n.get('UpgradedUrl_Placeholder_MobileFinalUrls') : '',
      errorContainer: 'MobileUrlErrors',
      ariaLabelledby: this.options.ariaPrefix + 'MobileUrlLabel',
      ariaId: this.options.ariaPrefix + 'MobileUrl',
      readOnly: this.options.readOnly
    });
    this.mobileUrl.on('urlChanged', function (value) {
      this.trigger('mobileUrlChanged', value);
    }, this);
    if (this.options.urlOptionsEnabled) {
      var UrlOptionsClass = this.options.useUrlOptionsV2 ? UrlOptionsV2 : UrlOptions;
      this.urlOptions = new UrlOptionsClass(_.extend({}, this.options, {
        editMode: this.options.urlOptionsEditMode,
        activityLogger: this.options.activityLogger
      })).render();
      this.urlOptions.on('testUurl', (function (fn, originalView) {
        this.trigger('testUurl', fn, originalView);
      }).bind(this));
    }
  },
  render: function () {
    this.$el.html(tmpl({
      i18n: i18n,
      showOnlyFinalUrl: this.options.showOnlyFinalUrl,
      popupHelpKeyAdLandingPage: this.options.popupHelpKeyAdLandingPage,
      ariaPrefix: this.options.ariaPrefix,
      readOnly: this.options.readOnly
    }));
    ko.applyBindings(this.ko_model, this.el);
    if (!this.options.showOnlyFinalUrl) {
      this.finalUrl.setElement(this.$('.final-url'));
      this.finalUrl.render();
    }
    var $url = this.$('.url');
    this.urlEditor.setElement($url);
    this.urlEditor.render();
    this.mobileUrl.setElement(this.$('.mobile-url'));
    this.mobileUrl.render();
    if (this.options.urlOptionsEnabled) {
      this.$el.find('.advanced-options').html(this.urlOptions.$el);
    }
    this.$('.url input.url-field').attr('name', 'FinalUrls');
    this.$('.mobile-url input.url-field').attr('name', 'MobileFinalUrls');
    this.on('finalUrlChanged', this.isValid);
    this.on('mobileUrlChanged', this.isValid);
    return this;
  },
  getValues: function () {
    if (!this.options.showOnlyFinalUrl) {
      return _.extend({
        finalUrl: {
          isFinal: this.finalUrl.getValues().isFinal,
          url: this.urlEditor.ko_model.fullUrl()
        },
        mobileUrl: this.finalUrl.ko_model.isFinalUrl() ? this.mobileUrl.ko_model.fullUrl() : null,
        trackingTemplate: this.finalUrl.ko_model.isFinalUrl() && this.urlOptions ? this.urlOptions.getTrackingTemplate() : null,
        customParameters: this.finalUrl.ko_model.isFinalUrl() && this.urlOptions ? this.urlOptions.getUrlCustomParameters(true) : []
      }, this.isFinalURLSuffixEnabled ? {
        finalUrlSuffix: this.finalUrl.ko_model.isFinalUrl() && this.urlOptions ? this.urlOptions.getFinalUrlSuffix() : null
      } : {});
    }
    return _.extend({
      finalUrl: {
        isFinal: true,
        url: this.urlEditor.ko_model.fullUrl()
      },
      mobileUrl: this.mobileUrl.ko_model.fullUrl(),
      trackingTemplate: this.urlOptions ? this.urlOptions.getTrackingTemplate() : null,
      customParameters: this.urlOptions ? this.urlOptions.getUrlCustomParameters(true) : []
    }, this.isFinalURLSuffixEnabled ? {
      finalUrlSuffix: this.urlOptions ? this.urlOptions.getFinalUrlSuffix() : null
    } : {});
  },
  handleApiErrors: function (errors) {
    if (!_.isEmpty(errors.FinalUrls)) {
      ko.observableArray.fn.push.apply(this.ko_model.landingPageUrlErrorMessages, errors.FinalUrls);
    }
    if (!_.isEmpty(errors.MobileFinalUrls)) {
      ko.observableArray.fn.push.apply(this.ko_model.errorMessages, errors.MobileFinalUrls);
    }
    if (this.urlOptions) {
      this.urlOptions.handleApiErrors(errors);
    }
  },
  clearApiErrors: function () {
    if (!_.isEmpty(this.ko_model.landingPageUrlErrorMessages())) {
      this.ko_model.landingPageUrlErrorMessages.remove(i18nErrors.isCampaignApiError);
    }
    if (!_.isEmpty(this.ko_model.errorMessages())) {
      this.ko_model.errorMessages.remove(i18nErrors.isCampaignApiError);
    }
    if (this.urlOptions) {
      this.urlOptions.clearApiErrors();
    }
  },
  clearAllErrors: function () {
    if (this.ko_model.landingPageUrlErrorMessages) {
      this.ko_model.landingPageUrlErrorMessages.removeAll();
    }
    if (this.ko_model.errorMessages) {
      this.ko_model.errorMessages.removeAll();
    }
    if (this.urlOptions) {
      this.urlOptions.clearApiErrors();
    }
  },
  toObject: function () {
    var values = this.getValues(), url = values.finalUrl.url, model = {};
    if (values.finalUrl.isFinal) {
      model.FinalUrls = url ? [url] : [];
      model.MobileFinalUrls = !this.isMobilePreferred && values.mobileUrl ? [values.mobileUrl] : [];
      model.TrackingUrlTemplate = values.trackingTemplate ? values.trackingTemplate : '';
      model.UrlCustomParameters = values.customParameters;
      if (this.isFinalURLSuffixEnabled) {
        model.FinalUrlSuffix = values.finalUrlSuffix || '';
      }
    } else {
      model.DestinationUrl = url ? url : '';
    }
    return model;
  },
  isValid: function () {
    var values = this.getValues(), errors = [], landingPageUrlErrorMessages = [];
    if (this.options.landingPageUrlRequired && !values.finalUrl.url) {
      var errorStr = _.isString(this.options.landingPageUrlRequired) ? this.options.landingPageUrlRequired : i18n.getString('Error_FinalUrl_Required');
      landingPageUrlErrorMessages.push(errorStr);
    }
    if (values.finalUrl.isFinal && values.mobileUrl && !values.finalUrl.url) {
      errors.push(i18n.getString('Error_Campaign_API_FinalUrlRequiredWhenUsingMobileFinalUrl'));
      !this.options.landingPageUrlRequired && landingPageUrlErrorMessages.push(i18n.getString('Error_FinalUrl_Required'));
    }
    if (this.options.highLightModeInError) {
      this.urlEditor.hasErrors(landingPageUrlErrorMessages.length > 0);
      this.mobileUrl.hasErrors(errors.length > 0);
    }
    this.ko_model.errorMessages(errors);
    this.ko_model.landingPageUrlErrorMessages(landingPageUrlErrorMessages);
    var errorMessageNotExists = !errors.length && !landingPageUrlErrorMessages.length;
    return this.urlOptions ? errorMessageNotExists && this.urlOptions.isValid() : errorMessageNotExists;
  },
  devicePreferenceChanged: function (event) {
    var checked = $(event.target).is(':checked');
    this.isMobilePreferred = checked;
    if (this.getValues().finalUrl.isFinal) {
      updateOnDevicePreference.call(this);
    }
  }
});
export default view;

